<template>
    <div>
      <!-- Adviseurs omgeving; Details adviseur -->
      <div v-if="Number(role) === 2">
        <div id="firstMenubar" class="row roundedtop menubar">
          <div class="title">Mijn informatie</div>
          <a
            v-if="style == 'db'"
            href="https://www.doelbeleggen.nl/agenda/atp"
            target="_blank"
            class="button"
            style="float:right;"
          >
            <awesomeIcon icon="phone-alt"/>
            <span class="mobile-hidden"> Plan een belafspraak in</span>
          </a>
        </div>
        <div class="card inset-small marginbottom" v-if="Number(role) == 2">
          <h3>Samen Doelbeleggen - dé portal voor adviserend Nederland</h3>
          <p>
            U bent in het informatiescherm waar u zelf uw gegevens en die van het bedrijf kan
            aanpassen.
          </p>
        </div>
      </div>
      <div class="flex-container flex-grow card inset">
        <div class="flex-100 subheader">Uw gegevens</div>
        <div class="flex-33">
          <customInput
            ref="focus"
            v-model="atp.advisorName"
            type="text"
            label="Naam*"
          />
        </div>
        <div class="flex-33">
          <customInput
            ref="focus"
            v-model="atp.advisorInfix"
            type="text"
            label="Tussenvoegsel"
            :validation="['notrequired']"
          />
        </div>
        <div class="flex-33">
          <customInput
            ref="focus"
            v-model="atp.advisorSurname"
            type="text"
            label="Achternaam*"
          />
        </div>

        <div class="flex-100 subheader">Kantoor gegevens</div>
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.name"
          type="text"
          label="Naam*"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.website"
          type="text"
          label="Website*"
        />
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.street"
          type="text"
          label="Straat*"
        />
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.housenr"
          type="text"
          label="Huisnummer*"
        />
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.housenrAddition"
          type="text"
          label="Toevoeging"
          :validation="['notrequired']"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.postal"
          type="text"
          placeholder="1111AA"
          label="Postcode*"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.city"
          type="text"
          label="Plaatsnaam*"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.phone"
          type="text"
          label="Telefoonnummer*"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.email"
          type="text"
          label="E-mailadres*"
          :validation="[ 'email']"
        />
        <customInput
          class="flex-100"
          ref="focus"
          v-model="atp.iban"
          type="text"
          label="Rekeningnummer (IBAN)"
          :validation="['notrequired','iban']"
        />
        <!-- KVK-nummer -->
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.kvk"
          type="text"
          label="KVK-nummer"
          :validation="['notrequired']"
        />
        <!-- Aantal adviseurs -->
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.totalAdvisors"
          type="dropdown"
          :options="[
            {label:'0-5', value:'0-5'},
            {label:'5-10', value:'5-10'},
            {label:'10+', value:'10+'},
          ]"
          label="Aantal adviseurs"
          :validation="['notrequired']"
        />
        <!-- Aantal klanten -->
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.customers"
          type="dropdown"
          :options="[
            {label:'0-500', value:'0-500'},
            {label:'500-1000', value:'500-1000'},
            {label:'1000+', value:'1000+'},
          ]"
          label="Aantal klanten"
          :validation="['notrequired']"
        />
        <div class="flex 33" style="margin-top: 10px;">
          <button title="opslaan" @click="updateAtpDetails()" style="float:right;">
            Opslaan
          </button>
        </div>
      </div>
      <div class="card inset" style="margin-top: 1.5rem;">
        <button style="width: 100%;" @click="uploadToggle = true">Veilig bestanden uploaden</button>
        <modalWindow v-if="uploadToggle" @close="uploadToggle = false" width="300">
          <div class="titlebar">Veilig bestanden uploaden</div>
          <div class="form-notice" v-if="tooltipText">
            {{tooltipText}}
          </div>
          <div class="inset">
              U kunt hieronder klikken op 'Kies een bestand' om een bestand veilig toe te voegen aan
              uw informatie.
            <label
              for="contactuploadfile" class="file-label button"
              style="display:block;height:initial;margin-top: 1.5rem;"
            >
              <awesomeIcon icon="upload"/> Bestanden uploaden
            </label>
            <input
              style="display:none" ref="files" id="contactuploadfile"
              type="file" name="img" multiple @change="uploadFilesChanged"
            >
          </div>
        </modalWindow>
      </div>
    </div>
  </template>

<script>
export default {
  name: 'AtpDetails',
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      uploadToggle: false,
      tooltipText: '',
      atp: {
        city: null,
        name: null,
        street: null,
        housenr: null,
        housenrAddition: null,
        postal: null,
        website: null,
        phone: null,
        iban: null,
        email: null,
        advisorName: null,
        advisorInfix: null,
        advisorSurname: null,
        totalAdvisors: null,
        customers: null,
        kvk: null,
      },
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
  },
  created() {
    this.getAtpDetails();
  },
  methods: {
    uploadFilesChanged(e) {
      this.uploadFiles(e.target.files.length);
    },
    uploadFiles() {
      this.sdk.addFile(this.$refs.files.files, (response) => {
        if (response.status === 200) {
          // success
          this.tooltipText = 'We hebben uw bestanden ontvangen.';
        } else {
          this.tooltipText = 'Fout met uploaden. Wij accepteren alleen afbeeldingen en pdf bestanden.';
        }
      });
    },
    getAtpDetails() {
      this.sdk.getAtpDetails((response) => {
        if (response.status === 200) {
          this.atp = {
            city: response.data[0].city,
            name: response.data[0].name,
            street: response.data[0].street,
            housenr: response.data[0].housenr,
            housenrAddition: response.data[0].housenr_addition,
            postal: response.data[0].postal,
            website: response.data[0].website,
            phone: response.data[0].phone,
            iban: response.data[0].iban,
            email: response.data[0].email,
            advisorName: response.data[0].advisor_name,
            advisorInfix: response.data[0].advisor_infix,
            advisorSurname: response.data[0].advisor_surname,
            totalAdvisors: response.data[0].total_advisors,
            customers: response.data[0].customers,
            kvk: response.data[0].kvk,
          };
        }
      });
    },
    checkIban(iban) {
      let sum = String(iban);
      sum = sum.replace(/ /gi, '');
      sum = sum.replace(' ', '');
      if (sum.length < 15) {
        return false;
      }

      sum = sum.slice(4) + sum.slice(0, 4);
      const letters = {
        a: 10,
        b: 11,
        c: 12,
        d: 13,
        e: 14,
        f: 15,
        g: 16,
        h: 17,
        i: 18,
        j: 19,
        k: 20,
        l: 21,
        m: 22,
        n: 23,
        o: 24,
        p: 25,
        q: 26,
        r: 27,
        s: 28,
        t: 29,
        u: 30,
        v: 31,
        w: 32,
        x: 33,
        y: 34,
        z: 35,
      };
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(letters)) {
        sum = sum.replace(new RegExp(key, 'gi'), value);
      }

      // eslint-disable-next-line
      function iso7064Mod97_10(iban) {
        let remainder = iban;
        let block;

        while (remainder.length > 2) {
          block = remainder.slice(0, 9);
          remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97;
      }

      sum = iso7064Mod97_10(sum);
      return sum === 1;
    },
    updateAtpDetails() {
      if (!this.atp.city
        || !this.atp.name
        || !this.atp.email
        || !this.atp.phone
        || !this.atp.website
        || !this.atp.postal
        || !this.atp.housenr
        || !this.atp.street
        || !this.atp.advisorName
        || !this.atp.advisorSurname
      ) {
        this.$store.state.confirm.toggle({
          alert: true,
          text: 'Niet alle velden zijn ingevuld',
          cb: () => {},
        });
        return;
      }
      if (this.atp.email) {
        const re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/g;
        if (!re.test(this.atp.email)) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: 'Dit is een onjuist email adres',
            cb: () => {},
          });
          return;
        }
      }
      if (this.atp.iban) {
        if (!this.checkIban(this.atp.iban)) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: 'Dit is een onjuist IBAN',
            cb: () => {},
          });
          return;
        }
      }
      this.sdk.updateAtpDetails(
        (response) => {
          if (response.status === 200) {
            this.$store.state.confirm.toggle({
              alert: true,
              text: 'Gegevens succesvol opgeslagen',
              cb: () => {},
            });
            this.getAtpDetails();
          }
        },
        this.atp.city,
        this.atp.name,
        this.atp.street,
        this.atp.housenr,
        this.atp.housenrAddition,
        this.atp.postal,
        this.atp.iban || '',
        this.atp.website,
        this.atp.phone,
        this.atp.email,
        this.atp.advisorName,
        this.atp.advisorInfix,
        this.atp.advisorSurname,
        this.atp.totalAdvisors,
        this.atp.customers,
        this.atp.kvk,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@media #{$mobile} {
  #firstMenubar {
    top: 91px !important;
  }
}
</style>
